import { bound } from '@cbridge-utils/redux';
import { ClientFeature } from '../feature.constant';
import { isFeatureEnabledSelector } from './isFeatureEnabled.selector';

/** Basic pricing + trading bridge; off → trading-related UI parts are hidden (LB-4724) */
export const isBasicBridgeEnabledSelector = bound(isFeatureEnabledSelector, { feature: ClientFeature.BasicBridge });

/** Independent markout (risk reporting) for the tenant (LB-4701) */
export const isRiskManagementEnabledSelector = bound(isFeatureEnabledSelector, { feature: ClientFeature.RiskManagement });
